export const loadingProps = loading => ({
  loading,
  disabled: loading
});
